import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Box } from '@wix/design-system';
import { Confirm, Dismiss } from '@wix/wix-ui-icons-common/lazy';
import { StringElement } from './StringElement';
import { DATA_HOOKS } from './CheckListView.driver';
export function CheckListView(_ref) {
  let {
    items,
    checkIcon,
    uncheckIcon,
    iconGap,
    defaultCheckValue,
    defaultTextProps,
    dataHook,
    ...boxProps
  } = _ref;
  const CheckIcon = checkIcon ?? /*#__PURE__*/React.createElement(Confirm, {
    color: "#25A55A"
  });
  const UnCheckIcon = uncheckIcon ?? /*#__PURE__*/React.createElement(Dismiss, {
    color: "#E62214"
  });
  const textProps = {
    size: 'small',
    skin: 'standard',
    ...defaultTextProps
  };
  return /*#__PURE__*/React.createElement(Box, _extends({
    gap: "12px",
    direction: "vertical"
  }, boxProps, {
    dataHook: dataHook ?? DATA_HOOKS.component
  }), items.map((item, index) => {
    const content = item.content ?? item;
    const checked = item.content != null ? item.checked ?? defaultCheckValue : defaultCheckValue;
    const ItemCheckIcon = item.checkIcon ?? CheckIcon;
    const ItemUncheckIcon = item.uncheckIcon ?? UnCheckIcon;
    return /*#__PURE__*/React.createElement(Box, {
      key: index // ok to use index as key here, since the list will not be reordered
      ,
      direction: "horizontal",
      maxWidth: "100%",
      whiteSpace: "break-spaces",
      textAlign: "left"
    }, /*#__PURE__*/React.createElement(Box, {
      marginRight: iconGap ?? '5px'
    }, checked ? ItemCheckIcon : ItemUncheckIcon), /*#__PURE__*/React.createElement(StringElement, _extends({}, textProps, {
      dataHook: DATA_HOOKS.item
    }), content));
  }));
}
//# sourceMappingURL=CheckListView.js.map